import { render, staticRenderFns } from "./Layout2x2.vue?vue&type=template&id=73529bd2&scoped=true&"
import script from "./Layout2x2.vue?vue&type=script&lang=js&"
export * from "./Layout2x2.vue?vue&type=script&lang=js&"
import style0 from "./Layout2x2.vue?vue&type=style&index=0&id=73529bd2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73529bd2",
  null
  
)

export default component.exports